import React from 'react';
import {
  DigitalGroundTruth,
  DigitalQuestion,
  GTNumberRangePayload,
  GTSingleChoicePayload,
  GTStringPayload,
  GroundTruthMultiChoice,
  GroundTruthMultiChoiceWithText,
  GroundTruthRatio,
  GroundTruthSingleChoiceWithText,
  QuestionTypeV2,
} from '../../redux/types';
import GTNumberRangeScore from './GTNumberRangeScore';
import GTSingleChoiceScore from './GTSingleChoiceScore';
import GTMultiChoiceScore from './GTMultiChoiceScore';
import GTRatioScore from './GTRatioScore';
import GTStringScore from './GTStringScore';
import GTSingleChoiceWithTextScore from './GTSingleChoiceWithTextScore';
import GTMultiChoiceWithTextScore from './GTMultiChoiceWithTextScore';

type Props = {
  question: DigitalQuestion;
  groundTruth?: DigitalGroundTruth;
}

const GTScores = ({
  question: dq,
  groundTruth: gt,
}: Props): JSX.Element => {
  if (dq.type === QuestionTypeV2.NumberRange && gt?.type === QuestionTypeV2.NumberRange) {
    return (
      <GTNumberRangeScore
        payload={gt.payload as GTNumberRangePayload}
      />
    );
  }
  if (dq.type === QuestionTypeV2.SingleChoice && gt?.type === QuestionTypeV2.SingleChoice) {
    return (
      <GTSingleChoiceScore
        payload={gt.payload as GTSingleChoicePayload}
        question={dq}
      />
    );
  }
  if (dq.type === QuestionTypeV2.MultiChoice && gt?.type === QuestionTypeV2.MultiChoice) {
    return (
      <GTMultiChoiceScore
        payload={gt.payload as GroundTruthMultiChoice['payload']}
        question={dq}
      />
    );
  }
  if (dq.type === QuestionTypeV2.Ratio && gt?.type === QuestionTypeV2.Ratio) {
    return (
      <GTRatioScore
        payload={gt.payload as GroundTruthRatio['payload']}
      />
    );
  }
  if (dq.type === QuestionTypeV2.String && gt?.type === QuestionTypeV2.String) {
    return (
      <GTStringScore
        payload={gt.payload as GTStringPayload}
      />
    );
  }
  if (dq.type === QuestionTypeV2.SingleChoiceWithText
    && gt?.type === QuestionTypeV2.SingleChoiceWithText) {
    return (
      <GTSingleChoiceWithTextScore
        payload={gt.payload as GroundTruthSingleChoiceWithText['payload']}
        question={dq}
      />
    );
  }
  if (dq.type === QuestionTypeV2.MultiChoiceWithText
    && gt?.type === QuestionTypeV2.MultiChoiceWithText) {
    return (
      <GTMultiChoiceWithTextScore
        payload={gt.payload as GroundTruthMultiChoiceWithText['payload']}
        question={dq}
      />
    );
  }
  return <span>-</span>;
};

export default GTScores;
